var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsumables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-nuts-2793774") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car-insurance---12---Filters",
    transform: "translate(-453.000000, -136.000000)",
    fill: "#8B48F2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(20.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29-Copy",
    transform: "translate(338.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-nuts-2793774",
    transform: "translate(30.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.07984791,9 C3.07984791,10.2705741 3.58460076,11.4891331 4.48302662,12.3876958 C5.38158935,13.2861217 6.60014829,13.7908745 7.87072243,13.7908745 C9.14129658,13.7908745 10.3598555,13.2861217 11.2584183,12.3876958 C12.1568441,11.4891331 12.661597,10.2705741 12.661597,9 C12.661597,7.72942586 12.1568441,6.51086692 11.2584183,5.61230418 C10.3598555,4.71387833 9.14129658,4.20912548 7.87072243,4.20912548 C6.60014829,4.20912548 5.38158935,4.71387833 4.48302662,5.61230418 C3.58460076,6.51086692 3.07984791,7.72942586 3.07984791,9 Z M11.4638783,9 C11.4638783,9.95297338 11.0853308,10.8669011 10.4114601,11.5407376 C9.73758935,12.2145741 8.82369582,12.5931559 7.87072243,12.5931559 C6.91774905,12.5931559 6.00382129,12.2146084 5.32998479,11.5407376 C4.65614829,10.8668669 4.27756654,9.95297338 4.27756654,9 C4.27756654,8.04702662 4.65611407,7.13309886 5.32998479,6.45926236 C6.00385551,5.78542586 6.91774905,5.40684411 7.87072243,5.40684411 C8.82369582,5.40684411 9.73762357,5.78539163 10.4114601,6.45926236 C11.0852966,7.13313308 11.4638783,8.04702662 11.4638783,9 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.428327,4.28680608 L8.17015209,0.0947908745 C8.07911863,0.0422555133 7.97578973,0.0145847909 7.87072243,0.0145847909 C7.76565513,0.0145847909 7.66232624,0.0422551711 7.57129278,0.0947908745 L0.313117871,4.28680608 C0.22181749,4.33960837 0.146025856,4.41553346 0.0933570342,4.50710076 C0.040821673,4.5985346 0.0132878327,4.70239734 0.0136838944,4.80786844 L0.0136838944,13.1918989 C0.0132871825,13.2973665 0.0408240684,13.4012327 0.0933570342,13.4926665 C0.146025856,13.5842338 0.22181749,13.6601589 0.313117871,13.7129612 L7.57129278,17.9049764 C7.66232624,17.9575118 7.76565513,17.9851825 7.87072243,17.9851825 C7.97578973,17.9851825 8.07911863,17.9575121 8.17015209,17.9049764 L15.428327,13.7129612 C15.5196274,13.6601589 15.595419,13.5842338 15.6480878,13.4926665 C15.7006232,13.4012327 15.728157,13.29737 15.727761,13.1918989 L15.727761,4.80786844 C15.7281577,4.70240076 15.7006208,4.5985346 15.6480878,4.50710076 C15.595419,4.41553346 15.5196274,4.33960837 15.428327,4.28680608 Z M14.530038,12.8443346 L7.87072243,16.6951711 L1.21140684,12.8446768 L1.21140684,5.15532319 L7.87072243,1.3048289 L14.530038,5.15532319 L14.530038,12.8443346 Z",
    id: "Shape"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumables);
export default __webpack_public_path__ + "static/media/consumables.ed59bd13fb38f7a072b8de4cf0eacaa8.svg";
export { ForwardRef as ReactComponent };